import { render } from "./AppResource.vue?vue&type=template&id=bb77da90"
import script from "./AppResource.vue?vue&type=script&lang=js"
export * from "./AppResource.vue?vue&type=script&lang=js"

import "./AppResource.vue?vue&type=style&index=0&id=bb77da90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__